export enum QueryKey {
  getAvailableProducts = 'getAvailableProducts',
  setOrder = 'setOrder',
}
